import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import payment from './images/payment.png'

const PaymentRecord = props => {
  const { t } = useTranslation()

  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.payment_record.title', 'Payment Record'),
          description: (
            <Trans i18nKey="b.liv_score.view.payment_record.text">
              A renter's <strong>Payment Record</strong> is determined based on how often they pay
              bills on time, and the frequency of late or missed payments. The Trust Score presents
              this information on a Poor to Excellent scale, as well as displaying the number of
              accounts checked.
            </Trans>
          ),
          image: payment
        })
      }
    />
  )
}

export default PaymentRecord
